import React from 'react';
import Loader from "react-js-loader";

const CustomLoader = ({type, color, size, title = ''}) => {
    return (
        <div className={"item"}>
            <Loader type={type} bgColor={color} title={title} size={size}/>
        </div>
    );
};

export default CustomLoader;
